module.exports = __webpack_public_path__ + "assets/img/image09.b566a200.png";